import { Box } from '@mui/material';
import React, { FC } from 'react';

interface VideoContainerProps {
  videoUrl: string;
}

const VideoContainer: FC<VideoContainerProps> = ({ videoUrl }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative'
      }}
    >
      <video
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          position: 'absolute',
          top: 0,
          left: 0
        }}
        controls={true}
        controlsList="nodownload"
        loop
        muted
        playsInline
        autoPlay={true}
        src={videoUrl}
      />
    </Box>
  );
};

export default VideoContainer;
